// ── SCROLL REVEAL ─────────────────────────────────────────
(function initScrollReveal() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(el => {
    observer.observe(el);
  });
})();

// ── CART DRAWER ─────────────────────────────────────────────
const CartDrawer = {
  el:       document.querySelector('[data-cart-drawer]'),
  overlay:  document.querySelector('[data-cart-overlay]'),
  body:     document.querySelector('[data-cart-body]'),
  footer:   document.querySelector('[data-cart-footer]'),
  countEl:  document.querySelector('[data-cart-count]'),

  open() {
    this.el.classList.add('is-open');
    this.overlay.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  },

  close() {
    this.el.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },

  updateCount(n) {
    if (!this.countEl) return;
    this.countEl.textContent = n;
    this.countEl.classList.toggle('is-hidden', n === 0);
  },

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  },

  renderItems(cart) {
    if (!this.body) return;
    if (cart.item_count === 0) {
      this.body.innerHTML = `<div class="cart-empty"><p class="cart-empty__text">Your cart is empty.</p><a href="/collections/all" class="btn-outline">Shop Now</a></div>`;
      if (this.footer) this.footer.style.display = 'none';
      return;
    }
    if (this.footer) this.footer.style.display = '';
    const items = cart.items.map(item => `
      <li class="cart-item" data-item-key="${item.key}">
        <div class="cart-item__img">${item.image ? `<img src="${item.image}" alt="${item.product_title}" width="72" height="72">` : ''}</div>
        <div class="cart-item__info">
          <p class="cart-item__name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <p class="cart-item__price">${this.formatMoney(item.final_price)}</p>
        </div>
        <div class="cart-item__qty">
          <button class="qty-btn" data-qty-change="${item.key}" data-delta="-1">&#x2212;</button>
          <span class="qty-value">${item.quantity}</span>
          <button class="qty-btn" data-qty-change="${item.key}" data-delta="1">+</button>
        </div>
      </li>`).join('');
    this.body.innerHTML = `<ul class="cart-items" data-cart-items>${items}</ul>`;
    const subtotalEl = this.footer && this.footer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
  },

  async refresh() {
    const cart = await fetch('/cart.js').then(r => r.json());
    this.updateCount(cart.item_count);
    this.renderItems(cart);
  },

  async addItem(variantId, qty = 1) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    await this.refresh();
    this.open();
  },

  async changeQty(key, delta) {
    const cart = await fetch('/cart.js').then(r => r.json());
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    const newQty = Math.max(0, item.quantity + delta);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    await this.refresh();
  }
};

document.addEventListener('click', e => {
  if (e.target.closest('[data-cart-trigger]'))  CartDrawer.open();
  if (e.target.closest('[data-cart-close]'))    CartDrawer.close();
  if (e.target.closest('[data-cart-overlay]'))  CartDrawer.close();
  const qtyBtn = e.target.closest('[data-qty-change]');
  if (qtyBtn) CartDrawer.changeQty(qtyBtn.dataset.qtyChange, parseInt(qtyBtn.dataset.delta, 10));
  const atcBtn = e.target.closest('[data-add-to-cart]');
  if (atcBtn) { e.preventDefault(); CartDrawer.addItem(atcBtn.dataset.addToCart); }
});

// ── PRODUCT IMAGE GALLERY ─────────────────────────────────
document.addEventListener('click', e => {
  const thumb = e.target.closest('[data-gallery-src]');
  if (!thumb) return;
  const main = document.getElementById('product-main-image');
  if (main) {
    main.style.opacity = '0';
    main.style.transform = 'scale(0.97)';
    setTimeout(() => {
      main.src = thumb.dataset.gallerySrc;
      main.style.opacity = '1';
      main.style.transform = 'scale(1)';
    }, 150);
  }
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('is-active'));
  thumb.classList.add('is-active');
});

// ── VARIANT SELECTOR ──────────────────────────────────────
document.addEventListener('change', e => {
  const select = e.target.closest('[data-variant-select]');
  if (!select) return;
  const id = select.value;
  const atcBtn = document.querySelector('[data-add-to-cart]');
  const variantInput = document.querySelector('[data-variant-id]');
  if (atcBtn) atcBtn.dataset.addToCart = id;
  if (variantInput) variantInput.value = id;
});

// ── FAQ ACCORDION ─────────────────────────────────────────
document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-faq-trigger]');
  if (!trigger) return;
  const item = trigger.closest('[data-faq-item]');
  const body = item.querySelector('[data-faq-body]');
  const isOpen = item.classList.contains('is-open');
  document.querySelectorAll('[data-faq-item].is-open').forEach(el => {
    el.classList.remove('is-open');
    el.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'false');
    el.querySelector('[data-faq-body]').style.maxHeight = '0';
  });
  if (!isOpen) {
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
});

// ── MOBILE NAV ────────────────────────────────────────────
document.addEventListener('click', e => {
  if (e.target.closest('[data-mobile-nav-trigger]')) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) {
      const isOpen = nav.classList.toggle('is-open');
      nav.setAttribute('aria-hidden', String(!isOpen));
    }
  }
});
